import { View } from "extensions/marionette";

import { store } from "common/store";

import loginTemplateFrame from "common/features/login/templateFrame.jst";
import merchantPickerFullPartial from "./merchantPickerFullPartial.jst";

export const MerchantPickerFullPageView = View.extend({
    className: "merchant-picker-full",
    template: (data) => loginTemplateFrame({
        stretch: true,
        partial: merchantPickerFullPartial,
        ...data
    }),
    
    regions: {
        body: ".wrapper-body"
    },
    
    getErrorMessage() {
        const deniedAccessStatusCode = store.getState().config.deniedAccessStatusCode;
        if (deniedAccessStatusCode === 0) {
            return "";
        }
        
        if (deniedAccessStatusCode === 404) {
            return "The business unit you are trying to reach has either moved or no longer exists. Contact your admin to update your permissions.";
        }
        
        if (deniedAccessStatusCode === 403) {
            return "You do not have permission to view the requested merchant. If you believe this is an error, please contact us at <a href='mailto:help@pazien.com'>help@pazien.com</a>";
        }
        
        return "There was an internal error while loading this merchant, please contact us at <a href='mailto:help@pazien.com'>help@pazien.com</a>";
    },
    
    templateContext() {
        return {
            deniedAccessMessage: this.getErrorMessage()
        };
    },
    onRender() {
        this.showChildView("body", this.getOption("content"));
    }
});
